import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import  Payment from "../../components/Payment/PaymentListLayer";

const PaymentList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Payment History"  />

        <Payment />
      </MasterLayout>
    </>
  );
};

export default PaymentList;
